// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-link__path{vertical-align:middle}.e-link__path-item:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
